import type { UnwrapNestedRefs } from "vue";
import { onUnmounted, onMounted, onActivated, onDeactivated, isVNode, reactive, onBeforeMount } from "vue";
import type { ComputedRef, Ref } from "vue";
import $ from "jquery";
import type { UseRangDragToCopyType, SelectedActionType } from "../types";
import { copyText } from "@user-center/utils/index";
import { extractTextFromVNode } from "./render/index";
import { get } from "lodash-es";
import { ElMessage, ElMessageBox } from "element-plus";
interface TablePropsType {
  rangDragToCopy: boolean;
  tableHeaders: any[];
  targetScrollTopBottomWrapSelector: string;
  targetScrollBottomSelector: string;
  targetScrollTopSelector: string;
  data: any[];
}

const lastCopyTime: any = new Date().valueOf();
export function useRangDragToCopy(
  props: TablePropsType,
  ctx: any,
  willShowListData: ComputedRef<any[]>,
  tableScrollWrapEl: Ref<HTMLDivElement | null>,
  getShowListData: any
): UseRangDragToCopyType {
  let isActivated = true;
  const selectLock = false;
  let selectedCells = [];

  const selectedActionList: UnwrapNestedRefs<SelectedActionType[]> = reactive(
    []
  );

  const parentEl: any = tableScrollWrapEl.value;
  let startCell: any = null; // 开始的单元格
  let endCell: any = null; // 结束的单元格

  const isKeyDownMap: any = {}; // 记录哪个按键按下了
  let mousedownState = false; //是否按了按键c
  let isKeyCDown = false; //是否按了按键c
  let isKeyCtrlOrAltDown = false; //是否按了按键ctrl或alt
  const keyMap: any = {
    cKey: 67,
    leftKey: 37,
    rightKey: 39,
    bottomKey: 40,
    topKey: 38,
  };
  // 左边阔选
  function onKeyAltLeft() {
    if (!selectedActionList.length) return;
    console.log(
      "startEndCell",
      selectedActionList[selectedActionList.length - 1]
    );
    const { startCell } = selectedActionList[selectedActionList.length - 1];

    startCell[1] = 0;
  }

  // 右边阔选
  function onKeyAltRight() {
    if (!selectedActionList.length) return;
    console.log(
      "startEndCell",
      selectedActionList[selectedActionList.length - 1]
    );
    const { startCell, endCell } =
      selectedActionList[selectedActionList.length - 1];

    let headerLength = -1;
    props.tableHeaders.map((o: any) => {
      if (o.fixed != "right") {
        headerLength += 1;
      }
    });
    console.log("headerLength", headerLength);

    endCell[1] = headerLength;
  }

  // 上边阔选
  function onKeyAltTop() {
    if (!selectedActionList.length) return;
    console.log(
      "startEndCell",
      selectedActionList[selectedActionList.length - 1]
    );
    const { startCell } = selectedActionList[selectedActionList.length - 1];

    startCell[0] = 0;
  }

  // 下边阔选
  function onKeyAltBottom() {
    if (!selectedActionList.length) return;
    console.log(
      "startEndCell",
      selectedActionList[selectedActionList.length - 1]
    );
    const { endCell } = selectedActionList[selectedActionList.length - 1];

    const dataLength = willShowListData.value.length;

    endCell[0] = dataLength;

    const scrollEl: any = tableScrollWrapEl.value;
    scrollEl.scrollTop = scrollEl.scrollHeight;
    setTimeout(() => {
      scrollEl.scrollTop = scrollEl.scrollHeight;
    }, 500);
  }

  function onKeyDownFn(event: any) {
    console.log(event);

    if (!isActivated) return;

    isKeyCtrlOrAltDown = event.altKey || event.ctrlKey;
    if (
      event &&
      isKeyCtrlOrAltDown &&
      (event.keyCode == keyMap.topKey ||
        event.keyCode == keyMap.bottomKey ||
        event.keyCode == keyMap.leftKey ||
        event.keyCode == keyMap.rightKey)
    ) {
      event.preventDefault();
      event.stopPropagation();

      console.log("方向键盘");
      if (event.keyCode == keyMap.leftKey) {
        onKeyAltLeft();
      } else if (event.keyCode == keyMap.rightKey) {
        onKeyAltRight();
      } else if (event.keyCode == keyMap.topKey) {
        onKeyAltTop();
      } else if (event.keyCode == keyMap.bottomKey) {
        onKeyAltBottom();
      }
      return;
    }
    if (event && event.keyCode == keyMap.cKey) {
      isKeyCDown = true;
      if (selectedActionList.length) {
        const lastSelectedBlock: SelectedActionType =
          selectedActionList[selectedActionList.length - 1];

        if (selectedActionList.length >= 1) {
          //当有选中区域并且当前选中区域不为一个格子
          toCopyAllSelectedData();
        }
      }
    } else {
      isKeyCDown = false;
    }
  }
  function toCopyAllSelectedData() {
    // 将所有的选中区域模拟成一个最大范围的框，然后标记好那些是直接为空的

    let startMinRowIdx = -1;
    let startMinColumnIdx = -1;

    let endMaxRowIdx = -1;
    let endMaxColumnIdx = -1;

    selectedActionList.map((o: SelectedActionType) => {
      const { startCell, endCell } = o;
      startMinRowIdx =
        startMinRowIdx < 0
          ? startCell[0]
          : Math.min(startMinRowIdx, startCell[0]);
      startMinRowIdx =
        startMinRowIdx < 0 ? endCell[0] : Math.min(startMinRowIdx, endCell[0]);

      startMinColumnIdx =
        startMinColumnIdx < 0
          ? startCell[1]
          : Math.min(startMinColumnIdx, startCell[1]);
      startMinColumnIdx =
        startMinColumnIdx < 0
          ? endCell[1]
          : Math.min(startMinColumnIdx, endCell[1]);

      endMaxRowIdx =
        endMaxRowIdx < 0 ? startCell[0] : Math.max(endMaxRowIdx, startCell[0]);
      endMaxRowIdx =
        endMaxRowIdx < 0 ? endCell[0] : Math.max(endMaxRowIdx, endCell[0]);

      endMaxColumnIdx =
        endMaxColumnIdx < 0
          ? startCell[1]
          : Math.max(endMaxColumnIdx, startCell[1]);
      endMaxColumnIdx =
        endMaxColumnIdx < 0
          ? endCell[1]
          : Math.max(endMaxColumnIdx, endCell[1]);
    });
    const findStartRowColumn = [startMinRowIdx, startMinColumnIdx];
    const findEndRowColumn = [endMaxRowIdx, endMaxColumnIdx];

    if (!findStartRowColumn || !findEndRowColumn) {
      return;
    }
    const startRowIndex = Number(findStartRowColumn[0]);
    const startColumnIndex = Number(findStartRowColumn[1]);
    const endRowIndex = Number(findEndRowColumn[0]);
    const endColumnIndex = Number(findEndRowColumn[1]);
    console.log(
      `startRowIndex:${startRowIndex},startColumnIndex:${startColumnIndex},endRowIndex:${endRowIndex},endColumnIndex:${endColumnIndex},`
    );
    const selectedCells: any[] = [];
    for (
      let i: number = Math.min(startRowIndex, endRowIndex);
      i <= Math.max(startRowIndex, endRowIndex);
      i++
    ) {
      const rowItems: any[] = [];
      for (
        let j: number = Math.min(startColumnIndex, endColumnIndex);
        j <= Math.max(startColumnIndex, endColumnIndex);
        j++
      ) {
        let isSelectCopyFixedClass: any = false;
        const rowIndex = i;
        const columnIndex = j;
        selectedActionList.map((o: SelectedActionType) => {
          const rowMinIndex = Math.min(o.startCell[0], o.endCell[0]);
          const rowMaxIndex = Math.max(o.startCell[0], o.endCell[0]);
          const colMinIndex = Math.min(o.startCell[1], o.endCell[1]);
          const colMaxIndex = Math.max(o.startCell[1], o.endCell[1]);

          if (
            !isSelectCopyFixedClass &&
            rowMinIndex <= rowIndex &&
            rowIndex <= rowMaxIndex &&
            colMinIndex <= columnIndex &&
            columnIndex <= colMaxIndex
          ) {
            isSelectCopyFixedClass = true;
          }
        });

        rowItems.push({
          row: i,
          column: j,
          isSelected: isSelectCopyFixedClass,
        });
      }
      selectedCells.push(rowItems);
    }

    // 计算选中的行数和列数

    // 弹出选中的行数和列数
    console.log("selectedCells", selectedCells);
    const allCopyStr = assembleSelectContent(selectedCells);
    copy(allCopyStr, selectedCells.length);
  }
  function clearRangDrag() {
    isKeyCDown = false;
    startCell = null;
    endCell = null;
    selectedCells = [];
    if (tableScrollWrapEl && tableScrollWrapEl.value) {
      $(tableScrollWrapEl.value as any)
        .find(".fast-table__body__td__drag__will__copy")
        .removeClass("fast-table__body__td__drag__will__copy");
      (tableScrollWrapEl.value as any).removeEventListener(
        "mousemove",
        handleMouseMove
      );
    }

    document.removeEventListener("keyup", onKeyUpFn);
  }
  // 矩型选择
  function selectRangCells(findStartRowColumn: any, findEndRowColumn: any) {
    const startRowIndex = Number(findStartRowColumn[1]);
    const startColumnIndex = Number(findStartRowColumn[2]);
    const endRowIndex = Number(findEndRowColumn[1]);
    const endColumnIndex = Number(findEndRowColumn[2]);

    // 遍历所有的单元格，将开始到结束之间的单元格都添加样式
    for (
      let i = Math.min(startRowIndex, endRowIndex);
      i <= Math.max(startRowIndex, endRowIndex);
      i++
    ) {
      for (
        let j = Math.min(startColumnIndex, endColumnIndex);
        j <= Math.max(startColumnIndex, endColumnIndex);
        j++
      ) {
        const cell = (tableScrollWrapEl.value as any).querySelector(
          `.row${i}_column${j}`
        );
        if (cell) {
          cell.classList.add("fast-table__body__td__drag__will__copy");
          // selectedCells.push(cell);
        }
      }
    }
  }

  function onKeyUpFn(event: any) {
    console.log("onKeyUpFn", event.keyCode);
    if (
      event.keyCode == keyMap.topKey ||
      event.keyCode == keyMap.bottomKey ||
      event.keyCode == keyMap.leftKey ||
      event.keyCode == keyMap.rightKey
    ) {
      event.preventDefault();
      event.stopPropagation();

      console.log("方向键盘");

      return;
    }
    if (!isActivated) {
      clearRangDrag();
      return;
    }

    if (
      $(tableScrollWrapEl.value as any).find(
        ".fast-table__body__td__drag__will__copy"
      ).length <= 0
    ) {
      clearRangDrag();
      return;
    }
  }

  function assembleSelectContent(positionalData: any): string {
    const orgData = willShowListData.value;
    let str = "";
    for (let rowIdx = 0; rowIdx < positionalData.length; rowIdx++) {
      const rowItems: any = positionalData[rowIdx];
      let rowStr = "";
      for (let colIdx = 0; colIdx < rowItems.length; colIdx++) {
        let cellStr = "";
        try {
          const itemConf = positionalData[rowIdx][colIdx];
          const tableColConf = props.tableHeaders[itemConf.column];
          cellStr = "";
          if (!itemConf.isSelected) {
            cellStr = "	";
          } else {
            const setRowData =
              typeof orgData[itemConf.row] == "undefined"
                ? {}
                : orgData[itemConf.row];
            if (tableColConf.slots && tableColConf.slots.default) {
              cellStr = extractTextFromVNode(
                tableColConf.slots.default({
                  row: setRowData,
                  $index: itemConf.row,
                })
              );
            } else if (typeof tableColConf.formatter == "function") {
              cellStr = extractTextFromVNode(
                tableColConf.formatter(
                  setRowData,
                  tableColConf,
                  get(setRowData, tableColConf.prop),
                  itemConf.row
                )
              );
            } else {
              cellStr =
                get(setRowData, props.tableHeaders[itemConf.column].prop) || "	";
            }
          }
        } catch (e) {
          rowStr += "	";
          console.log(e);
        }

        rowStr += cellStr + "	";
      }
      str +=
        rowStr.replace(/\s+$/g, "") +
        (rowIdx + 1 == positionalData.length ? "" : "\r\n");
    }

    return str;
  }
  function removeAllSelectedClass(allCells?: any) {
    if (!allCells) {
      allCells = (tableScrollWrapEl.value as any).querySelectorAll(
        ".fast-table__body__td"
      );
    }
    allCells.forEach((cell: any) => {
      cell.classList.remove("fast-table__body__td__drag__will__copy");
    });
  }
  function handleMouseMove(event: any) {
    // console.log("handleMouseMove", event);
    if (!isActivated) return;
    //  console.log("event.buttons ", event.buttons);
    if (event.buttons != 1) {
      (tableScrollWrapEl.value as any).removeEventListener(
        "mousemove",
        handleMouseMove
      );
      return;
    }

    const targetCell = event.target.closest(".fast-table__body__td");
    const allCells = (tableScrollWrapEl.value as any).querySelectorAll(
      ".fast-table__body__td"
    );

    if (!targetCell) return;

    // 清除之前的样式
    removeAllSelectedClass(allCells);

    if (!startCell) {
      startCell = targetCell.className;
    } else {
      endCell = targetCell.className;
    }
    if (!startCell || !endCell) {
      return;
    }
    const findStartRowColumn = /row(\d+)_column(\d+)/g.exec(startCell);

    const findEndRowColumn = /row(\d+)_column(\d+)/g.exec(endCell);
    if (!findStartRowColumn || !findEndRowColumn) {
      return;
    }
    //    console.log("handleMouseMove findStartRowColumn, findEndRowColumn", event);
    selectRangCells(findStartRowColumn, findEndRowColumn);
  }
  //一键复制
  async function copy(text: string, row: number): Promise<void> {
    try {
      await copyText(text);
      ElMessage({
        type: "success",
        message: `成功复制 ${row} 条数据`,
      });
      selectedActionList.length = 0;
    } catch (e) {
      ElMessage({
        type: "warning",
        message: `自动复制失败,请手动复制`,
      });
      ElMessageBox.prompt(`共 ${row} 条数据`, "请手动复制", {
        inputType: "textarea",
        inputValue: text,
        customClass: "batch-copy-failure-data",
      });
      selectedActionList.length = 0;
    }
  }
  // function handleMouseMove(event: any) {
  //   const targetCell = event.target.closest(".fast-table__body__td");
  //   if (!targetCell) return;
  //   if (!startCell) {
  //     startCell = targetCell;
  //   } else {
  //     endCell = targetCell;
  //   }
  //   // 获取当前鼠标位置的单元格

  //   if (targetCell) {
  //     // 添加特定的class并将单元格存入选中的单元格数组
  //     targetCell.classList.add("fast-table__body__td__drag__will__copy");

  //     selectedCells.push(targetCell);
  //   }
  // }
  function onGlobalMouseDownFn(event: any) {
    if (
      !(tableScrollWrapEl && tableScrollWrapEl.value?.contains(event.target))
    ) {
      // console.log("鼠标点击发生在指定节点外");
      selectedActionList.length = 0;
      clearRangDrag();
    }
  }

  let activeScrollRequestIds: any[] = []; // 用于存储所有活动的请求 ID

  function scrollToAction(element: any, duration: number, direction = "down") {
    // 清空所有活动的请求 ID，确保新滚动前停止之前的所有滚动
 
    stopAllScrolls();

    const start = element.scrollTop;
    const end = direction === 'down' 
        ? element.scrollHeight - element.clientHeight // 滚动到底部
        : 0; // 滚动到顶部
    const change = end - start; // 计算总滚动距离
    const adjustedDuration = Math.abs(change / (element.scrollHeight - element.clientHeight)) * duration; // 根据滚动距离调整时间
    const startTime = performance.now();

    function animateScroll(currentTime) {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / adjustedDuration, 1); // 计算进度，确保不超过1

        // 使用 easeInOutQuad 函数计算滚动位置
        const easeInOutQuad = progress < 0.5 
            ? 2 * progress * progress 
            : -1 + (4 - 2 * progress) * progress;

        element.scrollTop = start + change * easeInOutQuad;

        // 如果进度小于1，继续动画
        if (progress < 1) {
            const requestId = requestAnimationFrame(animateScroll);
            activeScrollRequestIds.push(requestId); // 保存当前请求 ID
        }
    }

    // 启动动画
    const requestId = requestAnimationFrame(animateScroll);
    activeScrollRequestIds.push(requestId); // 保存当前请求 ID
  }

  function stopAllScrolls() {
    // 停止所有活动的请求
    activeScrollRequestIds.forEach((requestId) =>
      cancelAnimationFrame(requestId)
    );
    activeScrollRequestIds = []; // 清空活动请求 ID 列表
  }

  function initUseRangDragToCopy(): void {
    // 定义一个变量用于存储选中的单元格
    // 监听键盘按下事件
    if (tableScrollWrapEl && tableScrollWrapEl.value) {
      tableScrollWrapEl.value?.addEventListener(
        "mousedown",
        onTableMouseDownFn
      );
      tableScrollWrapEl.value?.addEventListener("mouseup", onTableMouseUpFn);
      document.removeEventListener("mouseup", onGlobalMouseDownFn);
      document.addEventListener("mouseup", onGlobalMouseDownFn);

      document.removeEventListener("keydown", onKeyDownFn);
      document.addEventListener("keydown", onKeyDownFn);
    }

    //   document.addEventListener("keydown", onKeyDownFn);
    // document.addEventListener("keydown", onKeyDownFn);
    // document.addEventListener("keyup", onGlobalKeyUpFn);
    // if (tableScrollWrapEl && tableScrollWrapEl.value)
    //   tableScrollWrapEl.value?.addEventListener("mouseleave", onMouseLeave);
    // 鼠标移动事件处理函数
  }

  function getTargetScrollBottomDom() {
    if (!tableScrollWrapEl.value) return null;
    if (
      props.targetScrollBottomSelector &&
      props.targetScrollTopBottomWrapSelector
    ) {
      let targetScrollBottomDom = $(tableScrollWrapEl.value)
        .closest(props.targetScrollTopBottomWrapSelector)
        .find(props.targetScrollBottomSelector);

      return targetScrollBottomDom;
    }
  }

  function getTargetTopBottomDom() {
    if (!tableScrollWrapEl.value) return null;
    if (
      props.targetScrollTopSelector &&
      props.targetScrollTopBottomWrapSelector
    ) {
      let targetScrollTopDom = $(tableScrollWrapEl.value)
        .closest(props.targetScrollTopBottomWrapSelector)
        .find(props.targetScrollTopSelector);

      return targetScrollTopDom;
    }
  }
  function filterClassIdx(cellClassName: string): number[] {
    const resRowColumn: any = /row(\d+)_column(\d+)/g.exec(cellClassName);
    return resRowColumn && resRowColumn[1]
      ? [resRowColumn[1], resRowColumn[2]]
      : [];
  }
  function onTableMouseUpFn(event: any) {
    console.log("onTableMouseUpFn", event);
    console.log("onTableMouseUpFn", startCell, endCell);
    if (!isActivated) return;

    if (!(startCell && endCell)) {
      return;
    }

    selectedActionList.push({
      startCell: filterClassIdx(startCell),
      endCell: filterClassIdx(endCell),
    });
    removeAllSelectedClass();
    console.log(selectedActionList);
    (tableScrollWrapEl.value as any).removeEventListener(
      "mousemove",
      handleMouseMove
    );
    mousedownState = false;
    let targetScrollBottomDom = getTargetScrollBottomDom();
    if (targetScrollBottomDom?.length) {
      targetScrollBottomDom.off("mouseover", autoScrollBottom);
      targetScrollBottomDom.off("mouseleave", unBindAutoScroll);
    }

    let targetScrollTopDom = getTargetTopBottomDom();
    if (targetScrollTopDom?.length) {
      targetScrollTopDom.off("mouseover", autoScrollTop);
      targetScrollTopDom.off("mouseleave", unBindAutoScroll);
    }
  }
  function onTableMouseDownFn(event: any) {
    console.log("onTableMouseDownFn", event);
    if (!isActivated) return;
    const targetCell = event.target.closest(".fast-table__body__td");
    if (selectedActionList.length == 1 && !event.altKey && !event.ctrlKey) {
      // 苹果用户先alt一下先
      selectedActionList.length = 0;
    }
    startCell = null;
    endCell = null;

    if (targetCell) {
      console.log("节点包含指定的样式");

      // 清空之前选中的单元格

      // 监听鼠标移动事件

      (tableScrollWrapEl.value as any).removeEventListener(
        "mousemove",
        handleMouseMove
      );
      (tableScrollWrapEl.value as any).addEventListener(
        "mousemove",
        handleMouseMove
      );
    } else {
      (tableScrollWrapEl.value as any).removeEventListener(
        "mousemove",
        handleMouseMove
      );
    }
    mousedownState = true;
    let targetScrollBottomDom = getTargetScrollBottomDom();
    if (targetScrollBottomDom?.length) {
      targetScrollBottomDom.off("mouseover", autoScrollBottom);
      targetScrollBottomDom.off("mouseleave", unBindAutoScroll);
      targetScrollBottomDom.on("mouseover", autoScrollBottom);
      targetScrollBottomDom.on("mouseleave", unBindAutoScroll);
    }
    let targetScrollTopDom = getTargetTopBottomDom();
    if (targetScrollTopDom?.length) {
      targetScrollTopDom.off("mouseover", autoScrollTop);
      targetScrollTopDom.off("mouseleave", unBindAutoScroll);
      targetScrollTopDom.on("mouseover", autoScrollTop);
      targetScrollTopDom.on("mouseleave", unBindAutoScroll);
    }
  }
  let scrollToSelectTimer: any = null;
  function autoScrollBottom(e: any) {
 
    if (mousedownState&&e.buttons==1) {
      // clearInterval(scrollToSelectTimer);
      // scrollToSelectTimer = setInterval(() => {
      //   let lastMoveSelect = selectedActionList[selectedActionList.length - 1];
      //   if (!lastMoveSelect) return;
      //   let showListData = getShowListData().value;

      //   lastMoveSelect[0] = showListData[showListData.length - 1].index;
      //   if (!lastMoveSelect[0]) return;
      //   console.log("lastMoveSelect", lastMoveSelect);
      // }, 500);
      scrollToAction(tableScrollWrapEl.value, 2000);
    }
  }

  function autoScrollTop(e: any) {
     
    if (mousedownState&&e.buttons==1) {
      // clearInterval(scrollToSelectTimer);
      // scrollToSelectTimer = setInterval(() => {
      //   let lastMoveSelect = selectedActionList[selectedActionList.length - 1];
      //   if (!lastMoveSelect) return;
      //   lastMoveSelect[0] = getShowListData().value[0].index;
      //   if (!lastMoveSelect || !lastMoveSelect[0]) return;
      //   if (!lastMoveSelect[0]) return;
      //   console.log("lastMoveSelect", lastMoveSelect);
      // }, 500);
      scrollToAction(tableScrollWrapEl.value, 2000, "top");
    }
  }
  function unBindAutoScroll() {
    console.log("unBindAutoScroll");
    clearInterval(scrollToSelectTimer);
    stopAllScrolls(); // 调用返回的停止函数，停止滚动
  }
  // 全局按钮按起事件
  function onGlobalKeyUpFn(event: any) {
    console.log("onGlobalKeyUpFn", event);
    isKeyCtrlOrAltDown = event.altKey || event.ctrlKey;
  }

  function onMouseLeave() {
    clearRangDrag();
  }
  function clearUseRangDragToCopy() {
    if (tableScrollWrapEl && tableScrollWrapEl.value)
      tableScrollWrapEl.value?.removeEventListener("mouseleave", onMouseLeave);
    document.removeEventListener("keyup", onGlobalKeyUpFn);
    document.removeEventListener("keydown", onKeyDownFn);
    document.removeEventListener("keyup", onKeyUpFn);
    clearRangDrag();
  }
  onBeforeMount(() => {});
  onMounted(() => {
    if (props.rangDragToCopy) {
      initUseRangDragToCopy();
    }
  });
  onUnmounted(() => {
    if (props.rangDragToCopy) {
      clearUseRangDragToCopy();
    }
  });

  onActivated(() => {
    if (props.rangDragToCopy) {
      isActivated = true;
    }
  });
  onDeactivated(() => {
    if (props.rangDragToCopy) {
      isActivated = false;
    }
  });

  return {
    content: "",
    selectedActionList,
  };
}
